/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class SectionMarkerCodes {
}
SectionMarkerCodes.BANNER_ALERTS_MARKER = 'alerts-marker';
SectionMarkerCodes.TOASTS_MARKER = 'toasts-marker';
SectionMarkerCodes.HEADER_MARKER = 'header-marker';
SectionMarkerCodes.NAVBAR_MARKER = 'navbar-marker';
SectionMarkerCodes.QUICKNAV_MARKER = 'quicknav-marker';
SectionMarkerCodes.CONTENT_MARKER = 'content-marker';
SectionMarkerCodes.FOOTER_MARKER = 'footer-marker';
SectionMarkerCodes.ALL_MARKERS = [
    SectionMarkerCodes.BANNER_ALERTS_MARKER,
    SectionMarkerCodes.TOASTS_MARKER,
    SectionMarkerCodes.HEADER_MARKER,
    SectionMarkerCodes.NAVBAR_MARKER,
    SectionMarkerCodes.QUICKNAV_MARKER,
    SectionMarkerCodes.CONTENT_MARKER,
    SectionMarkerCodes.FOOTER_MARKER
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VjdGlvbi1tYXJrZXItY29kZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc2hhcmVkL3BhZ2UtY3VzdG9taXphdGlvbnMvc2VjdGlvbi1tYXJrZXItY29kZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSCxNQUFNLE9BQU8sa0JBQWtCOztBQUNKLHVDQUFvQixHQUFHLGVBQWUsQ0FBQztBQUN2QyxnQ0FBYSxHQUFHLGVBQWUsQ0FBQztBQUNoQyxnQ0FBYSxHQUFHLGVBQWUsQ0FBQztBQUNoQyxnQ0FBYSxHQUFHLGVBQWUsQ0FBQztBQUNoQyxrQ0FBZSxHQUFHLGlCQUFpQixDQUFDO0FBQ3BDLGlDQUFjLEdBQUcsZ0JBQWdCLENBQUM7QUFDbEMsZ0NBQWEsR0FBRyxlQUFlLENBQUM7QUFFaEMsOEJBQVcsR0FBYTtJQUMzQyxrQkFBa0IsQ0FBQyxvQkFBb0I7SUFDdkMsa0JBQWtCLENBQUMsYUFBYTtJQUNoQyxrQkFBa0IsQ0FBQyxhQUFhO0lBQ2hDLGtCQUFrQixDQUFDLGFBQWE7SUFDaEMsa0JBQWtCLENBQUMsZUFBZTtJQUNsQyxrQkFBa0IsQ0FBQyxjQUFjO0lBQ2pDLGtCQUFrQixDQUFDLGFBQWE7Q0FDbkMsQ0FBQSJ9